import * as React from 'react';

export class SalesforceServiceCloudSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          id="fa59331f-733c-455d-93af-bdef5553b4d2"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 50 50"
      >
        <defs>
          <clipPath id="914bb057-dac8-47f3-acad-f54b28f63752">
            <rect x="1" y="8.20126" width="48" height="33.59749" fill="none"/>
          </clipPath>
          <clipPath id="d2421985-6b77-422a-9ad9-4cb2d6aad326">
            <rect x="0.9996" y="7.85623" width="48.0004" height="34.75891" fill="none"/>
          </clipPath>
          <clipPath id="6416808d-ca81-40b5-b2e0-9182de2c4853">
            <path
              d="M20.97417,11.86529a8.41275,8.41275,0,0,1,6.086-2.614,8.5,8.5,0,0,1,7.40607,4.39,10.2325,10.2325,0,0,1,4.186-.89,10.43909,10.43909,
              0,1,1-2.04,20.67618,7.56469,7.56469,0,0,1-9.91208,3.112,8.62861,8.62861,0,0,1-16.04213-.39A8.00777,8.00777,0,0,1,1,28.22543a8.10523,
              8.10523,0,0,1,4.006-7.01206,9.32151,9.32151,0,0,1,15.96814-9.34808"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="280885a6-4991-493e-81b8-199eadbbf45f">
            <path
              d="M7.95166,25.62381c-.03.08.01.096.02.108a2.63359,2.63359,0,0,0,.274.166,2.9235,2.9235,0,0,0,1.436.336c.984,0,1.596-.524,
              1.596-1.366v-.018c0-.778-.69-1.062-1.338-1.266l-.084-.028c-.488-.158-.91-.296-.91-.616v-.018c0-.274.246-.476.628-.476a2.8298,
              2.8298,0,0,1,1.252.32s.096.06.13-.032c.018-.05.182-.49.2-.538a.09407.09407,0,0,0-.048-.112,2.80283,2.80283,0,0,
              0-1.41-.378h-.098a1.37772,1.37772,0,0,0-1.532,1.326v.016c0,.822.694,1.088,1.344,
              1.274l.106.032c.474.146.882.272.882.604v.018c0,.304-.266.532-.694.532a2.328,2.328,0,0,
              1-1.268-.366c-.07-.04-.108-.068-.162-.102a.07883.07883,0,0,0-.13.046Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="8ad9c159-c025-4584-92f2-fac924129d7a">
            <path
              d="M22.366,25.62381c-.03.08.01.096.02.108a2.6334,2.6334,0,0,0,.274.166,2.9235,2.9235,0,0,0,1.436.336c.984,0,1.596-.524,
              1.596-1.366v-.018c0-.778-.69-1.062-1.338-1.266l-.084-.028c-.488-.158-.91-.296-.91-.616v-.018c0-.274.246-.476.628-.476a2.8298,
              2.8298,0,0,1,1.252.32s.096.06.13-.032c.018-.05.182-.49.2-.538a.09408.09408,0,0,0-.048-.112,2.7972,2.7972,0,0,
              0-1.41-.378h-.098a1.37772,1.37772,0,0,0-1.532,1.326v.016c0,.822.696,1.088,1.344,
              1.274l.106.032c.474.146.882.272.882.604v.018c0,.304-.266.532-.694.532a2.328,2.328,0,0,
              1-1.268-.366c-.07-.04-.11-.068-.162-.102a.08453.08453,0,0,0-.13.046Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="be801ee0-013a-4446-b0c2-cc335a1e9e16">
            <path
              d="M33.02846,23.08818a1.98084,1.98084,0,0,0-.374-.714,1.80021,1.80021,0,0,0-.632-.478,2.26909,2.26909,0,0,0-1.762,0,1.77452,1.77452,0,
              0,0-.63.48,1.95554,1.95554,0,0,0-.374.712,3.26368,3.26368,0,0,0,0,1.768,1.98085,1.98085,0,0,0,.374.714,1.755,1.755,0,0,0,.632.476,
              2.33723,2.33723,0,0,0,1.76,0,1.77209,1.77209,0,0,0,.632-.476,1.98083,1.98083,0,0,0,.374-.714,3.26368,3.26368,0,0,0,
              0-1.768m-.822.884a2.02267,2.02267,0,0,1-.264,1.118.88649.88649,0,0,1-.8.39.873.873,0,0,1-.796-.39,2.53381,2.53381,0,0,
              1-.002-2.232,1.02,1.02,0,0,1,1.598,0,2.00357,2.00357,0,0,1,.264,1.114"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="81966b14-8643-4527-8c10-bcc384dd3cc8">
            <path
              d="M39.77752,25.35281a.07907.07907,0,0,0-.106-.05,1.88258,1.88258,0,0,1-.382.11,2.852,2.852,0,0,1-.45.032,1.2534,1.2534,0,0,1-.94-.352,
              1.57194,1.57194,0,0,1-.352-1.124,1.73606,1.73606,0,0,1,.314-1.082,1.07457,1.07457,0,0,1,.912-.402,2.78668,2.78668,0,0,
              1,.87.124s.064.028.094-.056c.074-.2.126-.342.202-.562a.0728.0728,0,0,0-.05-.096,3.312,3.312,0,0,0-.548-.14,4.33123,4.33123,0,0,
              0-.618-.04,2.25114,2.25114,0,0,0-.914.176,1.88555,1.88555,0,0,0-.664.48,1.99345,1.99345,0,0,0-.398.714,2.79512,2.79512,0,0,
              0-.134.884,2.35737,2.35737,0,0,0,.546,1.636,2.07485,2.07485,0,0,0,1.622.61,3.35092,3.35092,
              0,0,0,1.164-.206.07586.07586,0,0,0,.034-.098Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="40ad957b-6d84-4ef6-9048-fc73a30b8e4c">
            <path
              d="M43.98156,22.93379a1.727,1.727,0,0,0-.354-.65,1.64608,1.64608,0,0,0-.53-.404,2.04467,2.04467,0,0,0-.796-.16,2.1731,2.1731,0,0,
              0-.918.178,1.84473,1.84473,0,0,0-.642.488,2.05349,2.05349,0,0,0-.376.722,3.10439,3.10439,0,0,0-.122.888,2.968,2.968,0,0,0,.126.888,
              1.837,1.837,0,0,0,.402.708,1.85848,1.85848,0,0,0,.7.464,2.779,2.779,0,0,0,1.01.162,2.881,2.881,0,0,0,
              1.402-.278c.032-.016.06-.046.024-.132l-.182-.51a.08138.08138,0,0,0-.106-.048,2.68884,2.68884,0,0,1-1.142.206,1.31774,1.31774,0,0,
              1-.95-.328,1.304,1.304,0,0,1-.324-.924l2.78.002a.08461.08461,0,0,0,.082-.074A2.97753,2.97753,0,0,0,43.98156,
              22.93379Zm-2.766.582a1.617,1.617,0,0,1,.226-.656.88364.88364,0,0,1,.794-.404.86441.86441,0,0,1,.78.404,1.38333,1.38333,0,0,1,.184.656Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="4a9b55b0-1803-4f31-9662-e25b936a0b6c">
            <path
              d="M21.69977,22.93379a1.72705,1.72705,0,0,0-.354-.65,1.62514,1.62514,0,0,0-.53-.404,2.04467,2.04467,0,0,0-.796-.16,2.1731,2.1731,0,0,
              0-.918.178,1.84471,1.84471,0,0,0-.642.488,2.05351,2.05351,0,0,0-.376.722,3.10439,3.10439,0,0,0-.122.888,2.968,2.968,0,0,0,.126.888,
              1.837,1.837,0,0,0,.402.708,1.85849,1.85849,0,0,0,.7.464,2.779,2.779,0,0,0,1.01.162,2.881,2.881,0,0,0,
              1.402-.278c.032-.016.06-.046.024-.132l-.182-.51a.08138.08138,0,0,0-.106-.048,2.68884,2.68884,0,0,1-1.142.206,1.31774,
              1.31774,0,0,1-.95-.328,1.304,1.304,0,0,1-.324-.924l2.78.002a.08461.08461,0,0,0,.082-.074A2.97748,2.97748,0,0,0,21.69977,
              22.93379Zm-2.766.582a1.64712,1.64712,0,0,1,.224-.656.88935.88935,0,0,1,.796-.404.86441.86441,0,0,
              1,.78.404,1.38331,1.38331,0,0,1,.184.656Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="a59492d3-f278-4e6e-ab5a-34d51142697d">
            <path
              d="M14.02611,23.38358c-.112-.01-.258-.014-.432-.014a2.6426,2.6426,0,0,0-.686.088,1.83124,1.83124,0,0,0-.582.27,1.30544,1.30544,0,0,
              0-.552,1.1,1.42816,1.42816,0,0,0,.128.634,1.13,1.13,0,0,0,.362.436,1.51667,1.51667,0,0,0,.568.246,3.31636,3.31636,0,0,0,.736.076,
              4.94581,4.94581,0,0,0,.846-.072c.272-.046.606-.114.7-.136.092-.02.194-.048.194-.048a.08808.08808,0,0,0,.064-.092l-.002-2.544a1.56051,
              1.56051,0,0,0-.44-1.228,1.89706,1.89706,0,0,0-1.28-.386,4.59481,4.59481,0,0,0-.744.07,2.68176,2.68176,0,0,0-.858.314.08821.08821,0,0,
              0-.026.11l.198.53a.07062.07062,0,0,0,.092.044.33492.33492,0,0,0,.046-.024,2.83756,2.83756,0,0,1,1.212-.282,1.12685,1.12685,0,0,
              1,.686.18c.152.118.23.292.23.664v.118c-.24-.036-.46-.054-.46-.054m-1.106,1.954a.5021.5021,0,0,1-.16-.166.652.652,0,0,
              1-.084-.36.61275.61275,0,0,1,.248-.54,1.24645,1.24645,0,0,1,.808-.2,5.44465,5.44465,
              0,0,1,.754.064v1.264a5.601,5.601,0,0,1-.75.1,1.252,1.252,0,0,1-.816-.162"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="26186f19-bb70-4008-a4a2-f447cf06acbb">
            <path
              d="M36.4671,21.949a.075.075,0,0,0-.042-.1,2.46732,2.46732,0,0,0-.466-.08,1.37876,1.37876,0,0,0-.718.116,1.26892,1.26892,0,0,
              0-.47.346v-.338a.08116.08116,0,0,0-.08-.084h-.712a.07993.07993,0,0,0-.08.084v4.15a.08323.08323,0,0,0,.084.084h.73a.08323.08323,0,0,0,
              .084-.084V23.969a2.40706,2.40706,0,0,1,.094-.73,1.04849,1.04849,0,0,1,.242-.408.85648.85648,0,0,1,.344-.208,1.33969,1.33969,0,0,1,
              .374-.052,1.5147,1.5147,0,0,1,.304.038c.056.006.084-.028.104-.076.046-.126.182-.508.208-.584"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="aa356f26-d24b-4b2a-be30-fbb785c7d999">
            <path
              d="M29.606,20.02576a1.93749,1.93749,0,0,0-.276-.064,2.08137,2.08137,0,0,0-.378-.03,1.5988,1.5988,0,0,0-1.178.422,2.30727,2.30727,0,0,
              0-.558,1.262l-.034.188H26.55a.09546.09546,0,0,0-.094.082l-.102.578c-.008.056.016.09.09.09h.614l-.624,3.482a4.32177,4.32177,0,0,
              1-.166.686,1.37548,1.37548,0,0,1-.194.396.517.517,0,0,1-.254.196,1.04868,1.04868,0,0,1-.328.046,1.21788,1.21788,0,0,
              1-.224-.024.66163.66163,0,0,1-.15-.048.07565.07565,0,0,0-.1.044c-.022.06-.186.51-.206.566a.08132.08132,0,0,0,.042.11,2.34519,
              2.34519,0,0,0,.254.076,1.71033,1.71033,0,0,0,.408.038,2.03873,2.03873,0,0,0,.684-.106,1.29722,1.29722,0,0,0,.514-.358,1.8338,
              1.8338,0,0,0,.36-.624,5.16363,
              5.16363,0,0,0,.246-.934l.626-3.546h.916a.09549.09549,0,0,0,.094-.082l.104-.578c.006-.054-.016-.09-.092-.09H28.08a3.686,3.686,0,0,
              1,.146-.626.81421.81421,0,0,1,.196-.298.60778.60778,0,0,1,.232-.146.98438.98438,0,0,1,.298-.042,1.113,1.113,0,0,
              1,.23.024c.086.018.12.028.142.034.09.028.102.002.12-.042l.212-.584a.074.074,0,0,0-.05-.098"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
          <clipPath id="f603b4a1-d523-4d17-a2e7-7611b147c21c">
            <path
              d="M17.17674,26.04281a.08116.08116,0,0,1-.08.084h-.738a.08116.08116,0,0,1-.08-.084v-5.938a.08116.08116,0,0,
              1,.08-.084h.738a.08116.08116,0,0,1,.08.084Z"
              fill="none"
              clipRule="evenodd"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#914bb057-dac8-47f3-acad-f54b28f63752)">
          <g>
            <g clipPath="url(#d2421985-6b77-422a-9ad9-4cb2d6aad326)">
              <g clipPath="url(#6416808d-ca81-40b5-b2e0-9182de2c4853)">
                <g clipPath="url(#d2421985-6b77-422a-9ad9-4cb2d6aad326)">
                  <rect x="-7.27593" y="-0.07466" width="64.55227" height="50.15014" fill="#009cdb"/>
                </g>
              </g>
            </g>
          </g>
        </g>
        <g clipPath="url(#280885a6-4991-493e-81b8-199eadbbf45f)">
          <rect x="-0.33524" y="13.42984" width="19.88885" height="21.0799" fill="#fff"/>
        </g>
        <g clipPath="url(#8ad9c159-c025-4584-92f2-fac924129d7a)">
          <rect x="14.07908" y="13.42984" width="19.88885" height="21.0799" fill="#fff"/>
        </g>
        <g clipPath="url(#be801ee0-013a-4446-b0c2-cc335a1e9e16)">
          <rect x="20.85851" y="13.44225" width="20.56789" height="21.0519" fill="#fff"/>
        </g>
        <g clipPath="url(#81966b14-8643-4527-8c10-bcc384dd3cc8)">
          <rect x="28.33757" y="13.43884" width="19.92442" height="21.0519" fill="#fff"/>
        </g>
        <g clipPath="url(#40ad957b-6d84-4ef6-9048-fc73a30b8e4c)">
          <rect x="31.96761" y="13.44385" width="20.40019" height="21.04995" fill="#fff"/>
        </g>
        <g clipPath="url(#4a9b55b0-1803-4f31-9662-e25b936a0b6c)">
          <rect x="9.68581" y="13.44385" width="20.40019" height="21.04995" fill="#fff"/>
        </g>
        <g clipPath="url(#a59492d3-f278-4e6e-ab5a-34d51142697d)">
          <rect x="3.49816" y="13.43764" width="20.15002" height="21.05791" fill="#fff"/>
        </g>
        <g clipPath="url(#26186f19-bb70-4008-a4a2-f447cf06acbb)">
          <rect x="25.62314" y="13.48846" width="19.12572" height="20.91448" fill="#fff"/>
        </g>
        <g clipPath="url(#aa356f26-d24b-4b2a-be30-fbb785c7d999)">
          <rect x="16.52937" y="11.65584" width="21.40791" height="24.74192" fill="#fff"/>
        </g>
        <g clipPath="url(#f603b4a1-d523-4d17-a2e7-7611b147c21c)">
          <rect x="8.0028" y="11.74483" width="17.44987" height="22.65791" fill="#fff"/>
        </g>
      </svg>
    )
  }
}